import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataService } from '../../../../../services/data.service';
import { SpinnerService } from 'shared-components';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-grid-estadisticas-etiquetado-cpd',
    templateUrl: './grid-estadisticas-etiquetado-cpd.component.html'
})
export class GridEstadisticasEtiquetadoCpdComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 5;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 1;
    public totalItems: number;
    public firstItemList = 0;
    public lastItemList = this.itemsPerPage;
    public readonly visiblePages = 3;

    public data;

    public showPais = false;
    public showDenominacion = false;
    public showCampanya = false;
    public showEtiquetador = false;

    public desPais;
    public desDenominacion;
    public desCampanya;

    @Input() titulo: string;
    @Input() dataGrid: any;

    @Output() refresh = new EventEmitter<boolean>();

    constructor(
        private readonly _translate: TranslateService,
        private readonly _dataService: DataService,
        private readonly _spinnerService: SpinnerService
    ) { }

    ngOnInit() {
        this.getDataGrid();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public getDataGrid(){
        let filters = {
            lsPaisId: this.dataGrid.paisId,
            lsDenominacionId: this.dataGrid.denominacionId,
            lsCampanyasDeAnyo: this.dataGrid.anyo == 0 || !this.dataGrid.anyo ? [] : typeof this.dataGrid.anyo == 'number' ? [this.dataGrid.anyo] : this.dataGrid.anyo
        };
        this.desCampanya = filters.lsCampanyasDeAnyo.length == 0 ? null : filters.lsCampanyasDeAnyo.join(", ");
        this.desDenominacion = this.dataGrid.denominacion ? this.dataGrid.denominacion : '';
        this.desPais = this.dataGrid.pais ? this.dataGrid.pais : '';
        this._spinnerService.showSpinner();
        this._dataService[this.dataGrid.service](filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            if (resp) {
                resp = resp.some(a=> a.lsEtqAnyoPaisDenominacionDto) ? resp.map(c=>c.lsEtqAnyoPaisDenominacionDto).reduce((acc, curr) => acc.concat(curr), []) : resp;
                this.showPais = resp.some(a => a.paisId) ? true : false;
                this.showDenominacion = resp.some(a => a.denominacionId) ? true : false;
                this.showCampanya = resp.some(a => a.anyo) ? true : false;
                this.showEtiquetador = resp.some(a => a.etiquetadorId) ? true : false;
                this.totalItems = resp.length;
                this.data = resp;
            }
        });
    }

    public pageChange(page) {
        this.currentPage = page;
        this.firstItemList = this.itemsPerPage * (page - 1);
        this.lastItemList = this.itemsPerPage * page;
    }

    public itemsPerPageChange(items) {
        this.currentPage = 1;
        this.itemsPerPage = items;
        this.firstItemList = 0;
        this.lastItemList = items;
    }

    public close() {
        this.refresh.emit(true);
    }

}
